var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconComplexes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC801",
    fillRule: "evenodd",
    d: "M1.299 0C.58 0 0 .59 0 1.316v17.368C0 19.411.581 20 1.299 20H18.7C19.42 20 20 19.41 20 18.684V1.316C20 .589 19.419 0 18.701 0H1.3Zm3.636 4.737c.016-.099.008-.397.003-.607l-.003-.183c0-1.308-.93-2.368-2.078-2.368C1.71 1.579.78 2.639.78 3.947v.79c0 .98.662 1.805 1.559 2.039v10.856c0 .145.116.263.26.263h.519c.143 0 .26-.118.26-.263V6.776a2.101 2.101 0 0 0 1.558-2.04Zm11.818-3.158h-.65v4.23l.375.514.623.256h.042v11.053c0 .145.116.263.26.263h.52c.143 0 .259-.118.259-.263V6.579h.041l.624-.256.374-.385V1.579h-.624v2.949h-.527V1.579h-.797v2.949h-.52V1.579Zm-.65 9.21c0 3.343-2.674 6.053-5.973 6.053-3.3 0-5.974-2.71-5.974-6.052 0-3.343 2.675-6.053 5.974-6.053 3.3 0 5.974 2.71 5.974 6.053Zm-5.973 3.685c2.008 0 3.636-1.65 3.636-3.684 0-2.035-1.628-3.685-3.636-3.685s-3.636 1.65-3.636 3.684c0 2.035 1.628 3.685 3.636 3.685Zm0 .526c2.295 0 4.156-1.885 4.156-4.21 0-2.326-1.86-4.211-4.156-4.211-2.295 0-4.156 1.885-4.156 4.21 0 2.326 1.86 4.211 4.156 4.211Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComplexes);
export default ForwardRef;